// RoleShell.jsx — En-tête brandé partagé pour les interfaces dédiées par rôle.
import { useEffect, useState } from 'react';
import { LogOut, Sparkles } from 'lucide-react';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

export function RoleShell({ roleLabel, title, subtitle, children, testid }) {
  const { user, logout } = useAuth();
  const [asso, setAsso] = useState({ nom: user?.asso_nom, logo_url: null });
  const accent = user?.couleur_principale || '#0047FF';

  useEffect(() => {
    api.get('/assos/me').then(({ data }) => setAsso({ nom: data.nom, logo_url: data.logo_url })).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F9F8] text-[#0F172A] font-sans antialiased" data-testid={testid}>
      {/* Header brandé sticky */}
      <header className="sticky top-0 z-30 bg-white/90 backdrop-blur border-b border-[#F1F5F9]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            {asso.logo_url
              ? <img src={asso.logo_url} alt={asso.nom} className="h-9 w-auto" />
              : <div className="w-9 h-9 rounded-xl grid place-items-center text-white font-display font-black shrink-0" style={{ background: accent }}>{(asso.nom || 'A')[0]}</div>}
            <div className="min-w-0">
              <div className="font-display font-black text-[#0F172A] truncate leading-tight">{asso.nom}</div>
              <div className="text-[11px] font-bold uppercase tracking-[0.14em]" style={{ color: accent }}>{roleLabel}</div>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {user?.is_demo && (
              <span className="hidden sm:inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[#0047FF] bg-[#0047FF]/10 px-2 py-1 rounded-full">
                <Sparkles className="w-3 h-3" /> Démo
              </span>
            )}
            <button
              onClick={logout}
              className="inline-flex items-center gap-1.5 text-sm font-bold text-[#475569] hover:text-[#0F172A] border-2 border-[#F1F5F9] hover:border-[#E2E8F0] rounded-lg px-3 py-1.5 transition-colors"
              data-testid="role-logout-btn"
            >
              <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Quitter</span>
            </button>
          </div>
        </div>
      </header>

      {/* Contenu */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <div className="mb-6">
          <h1 className="font-display text-3xl sm:text-4xl font-black text-[#0F172A]">{title}</h1>
          {subtitle && <p className="text-[#475569] mt-1">{subtitle}</p>}
        </div>
        {children}
      </main>
    </div>
  );
}
